import {Dictionary} from "lodash";
import {PAGE, ReferralConsideration} from "../../const";
import {
    ClientProviderPreference,
    CompleteReferralOffers,
    MatchedProviderOffers,
    Offer,
    OpenForPlacementOffers,
    Referral
} from "../../domains";

export function isOfferDoesntIncludeClinic(offer: Offer | null, referral: Referral | undefined): boolean {
    if (offer && referral && referral.referralConsiderations) {
        return referral.referralConsiderations.includes(ReferralConsideration.ClinicBased) && !offer.provideServicesInClinic;
    }
    return false;
}

export function filterOfferByRecentPage(offers: Offer[], recentPage: PAGE): Array<Offer> {
    let filteredOffers: Offer[];

    if (recentPage === PAGE.COMPLETE_REFERRALS) {
        filteredOffers = CompleteReferralOffers(offers);
    } else if (recentPage === PAGE.MATCHED_REFERRALS) {
        filteredOffers = MatchedProviderOffers(offers);
    } else {
        filteredOffers = OpenForPlacementOffers(offers);
    }

    return filteredOffers;
}

export function preferencesForSibling(offersByReferralGuid: Dictionary<Offer[]>, recentPage: PAGE): ClientProviderPreference[] {
    let referralCount = 0;
    const providerCountMap = new Map();
    Object.entries(offersByReferralGuid).forEach(([_, listOffers]) => {
        referralCount++;
        filterOfferByRecentPage(listOffers, recentPage).forEach((offer: Offer) => {
            const current = providerCountMap.has(offer.providerSfId) ? providerCountMap.get(offer.providerSfId) : 0;
            providerCountMap.set(offer.providerSfId, current + 1);
        })
    });

    let res: ClientProviderPreference[] = [];
    providerCountMap.forEach((count: number, key: string) => {
        if (count === referralCount && referralCount > 1) {
            res.push({
                sfProviderId: key,
                clientPreference: 'Preferred_Provider',
                preferenceReason: 'Submitted Offer for Sibling'
            });
        }
    });

    return res;
}

function providerGuidsHasAtLeastOneMatched(referralByGuid: Dictionary<Referral[]>, offersByReferralGuid: Dictionary<Offer[]>, recentPage: PAGE): Set<String> {
    const prefs = preferencesForSibling(offersByReferralGuid, recentPage);
    const sfProviderIdSet = new Set<String>(prefs.map((pref) => pref.sfProviderId));
    let providersHasAtLeastOneMatched = new Set<String>();
    Object.entries(offersByReferralGuid).forEach(([referralGuid, listOffers]) => {
        filterOfferByRecentPage(listOffers, recentPage).forEach((offer: Offer) => {
            const referral = referralByGuid[referralGuid][0] as Referral;
            if (sfProviderIdSet.has(offer.providerSfId ?? '')
                && referral.matchedOffer
                && offer.guid === referral.matchedOffer.guid) {
                providersHasAtLeastOneMatched.add(offer.providerSfId!);
            }
        });
    })

    return providersHasAtLeastOneMatched;
}

export function isSelectedOfferProviderNotMatchSiblingProvider(referralByGuid: Dictionary<Referral[]>,
                                                               offersByReferralGuid: Dictionary<Offer[]>,
                                                               currentSelectedOffer: Offer | null,
                                                               recentPage: PAGE): boolean {
    if (currentSelectedOffer == null) {
        return false;
    } else {
        const providerGuidsHasMatched = providerGuidsHasAtLeastOneMatched(referralByGuid, offersByReferralGuid, recentPage);
        return providerGuidsHasMatched.size !== 0 &&
            referralByGuid[currentSelectedOffer.referralGuid!][0].matchedOffer === null &&
            !providerGuidsHasMatched.has(currentSelectedOffer?.providerSfId ?? '');
    }
}

